/***
 * @file: 
 * @author: xiaoyu.chen
 * @Date: 2025-09-05 14:11:40
 */
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn'

export default defineNuxtPlugin((nuxtApp) => {
    dayjs.locale('zh-cn')
    nuxtApp.provide('dayjs', dayjs)
    console.log('dayjs plugin loaded')
})
